<template>
  <div class="assessfirst row-test">
    <v-row justify="center">
      <v-col cols="7">
        <vacancy-title />
      </v-col>
    </v-row>

    <div class="assessfirst__body">
      <v-row justify="center">
        <v-col cols="7">
          <div class="assessfirst__header">Assess First</div>

          <div class="assessfirst__description">
            {{
              $tr('integrations.hackerrank.vacancy-description', {
                integrationName: 'Assess First'
              })
            }}
          </div>

          <switcher
            class="assessfirst__switcher"
            :value="isVacancyAssessfirstConnected"
            :disabled="isAssessfirstLoading"
            :text="$tr('integrations.hackerrank.toggle-step')"
            @input="toggleAssessfirstToVacancy(Number(vcvVacancyId))"
          />

          <transition name="fade">
            <div v-if="isVacancyAssessfirstConnected" class="assessfirst__form">
              <div class="assessfirst__form-block">
                <h3 class="assessfirst__form-block-header">
                  {{ $tr('vacancy.preferences.settings.selectLanguage') }}
                </h3>

                <multiselect
                  :value="assessfirstCurrentLocale"
                  :options="getAssessfirstLocalesForSelect"
                  :disabled="isAssessfirstLoading"
                  :placeholder="$tr('vacancy.preferences.settings.selectLanguage')"
                  :searchable="false"
                  :allow-empty="false"
                  :show-labels="false"
                  label="name"
                  open-direction="bottom"
                  track-by="code"
                  class="big"
                  @input="SET_ASSESSFIRST_CURRENT_LOCALE"
                />
              </div>

              <div class="assessfirst__form-block">
                <h3 class="assessfirst__form-block-header">
                  {{ $tr('integrations.assessfirst.choose-campaign') }}
                </h3>

                <multiselect
                  :value="assessfirstCurrentCampaign"
                  :options="getAssessfirstCampaignsForSelect"
                  :disabled="isAssessfirstLoading"
                  :placeholder="$tr('vacancy.preferences.settings.selectLanguage')"
                  :searchable="false"
                  :allow-empty="false"
                  :show-labels="false"
                  label="name"
                  open-direction="bottom"
                  track-by="code"
                  class="big"
                  @input="SET_ASSESSFIRST_CURRENT_CAMPAIGN"
                />
              </div>

              <transition name="fade">
                <div v-if="assessfirstCurrentCampaign" class="assessfirst__form-block">
                  <switcher
                    class="assessfirst__switcher assessfirst__mb"
                    :value="assessfirstDropout"
                    :disabled="isAssessfirstLoading"
                    :text="$tr('vacancy.preferences.application.dateDropout')"
                    @input="SET_ASSESSFIRST_TOGGLE_DROPOUT"
                  />

                  <div class="assessfirst__label">
                    {{ $tr('integrations.assessfirst.percent') }}
                  </div>

                  <vinput
                    class="assessfirst__input"
                    type="number"
                    :disabled="!assessfirstDropout || isAssessfirstLoading"
                    :value="assessfirstDropoutPercent"
                    border
                    @input="SET_ASSESSFIRST_DROPOUT_PERCENT"
                  />

                  <vbutton
                    :text="$tr('actions.save')"
                    :loading="isAssessfirstLoading"
                    @click="saveAssessfirstCampaign"
                  />
                </div>
              </transition>
            </div>
          </transition>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import VacancyTitle from '@/routes_new/inner/vacancy/components/vtitle';

  export default {
    name: 'VacancyAssessfirst',

    components: {
      VacancyTitle
    },

    computed: {
      ...mapState('vacancy_new', { vcvVacancyId: state => state.item.id }),

      ...mapState('integrationsAssessfirst', [
        'isAssessfirstLoading',
        'connectedVacancies',
        'assessfirstCurrentLocale',
        'assessfirstCurrentCampaign',
        'assessfirstDropout',
        'assessfirstDropoutPercent'
      ]),

      ...mapGetters('integrationsAssessfirst', [
        'isVacancyAssessfirstConnected',
        'getAssessfirstLocalesForSelect',
        'getAssessfirstCampaignsForSelect'
      ])
    },

    async created() {
      await this.fetchAssessfirstLocales();
      await this.fetchAssessfirstCampaigns();
      await this.checkExistingConnection(Number(this.vcvVacancyId));
    },

    methods: {
      ...mapMutations('integrationsAssessfirst', [
        'SET_ASSESSFIRST_CURRENT_CAMPAIGN',
        'SET_ASSESSFIRST_TOGGLE_DROPOUT',
        'SET_ASSESSFIRST_DROPOUT_PERCENT',
        'SET_ASSESSFIRST_CURRENT_LOCALE'
      ]),

      ...mapActions('integrationsAssessfirst', [
        'checkExistingConnection',
        'toggleAssessfirstToVacancy',
        'fetchAssessfirstLocales',
        'fetchAssessfirstCampaigns',
        'saveAssessfirstCampaign'
      ])
    }
  };
</script>

<style lang="scss" scoped>
  .assessfirst {
    margin-bottom: 200px;

    &__header {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    &__description {
      margin-bottom: 20px;
    }

    &__form-block {
      margin-top: 50px;
    }

    &__form-block-header {
      margin-bottom: 7px;
    }

    &__form {
      margin: 20px 0;
    }

    &__label {
      margin-bottom: 5px;
      margin-top: 40px;
    }

    &__input {
      width: 200px;
      margin-bottom: 30px;
    }

    &__mb {
      margin-bottom: 20px;
    }
  }
</style>
